<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            Vendors
            <add-button link="/main/vendors/create"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Vendors</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Organization</th>
                        <th>Address 1</th>
                        <th>Address 2</th>
                        <!-- <th>State</th> -->
                        <th>State Code</th>
                        <th>Country</th>
                        <th>Is Gst Regster</th>
                        <th>Gst In</th>
                        <th>Pan No</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="8"></loading-table>
                      <router-link 
                        v-for="(vendor, at) in vendors"
                        :key="`vendor${at}`"
                        :to="`/main/vendors/${vendor.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ vendor.name || '' }}</td>
                        <td>{{ vendor.email }}</td>
                        <td>{{ vendor.phone }}</td>
                        <td>{{ vendor.organization }}</td>
                        <td>{{ vendor.address_1 }}</td>
                        <td>{{ vendor.address_2 }}</td>
                        <!-- <td>{{ vendor.state }}</td> -->
                        <td>{{ vendor.state_code }}</td>
                        <td>{{ vendor.country }}</td>
                        <td>{{ vendor.is_gst_register == 1 ? 'YES' : 'NO' }}</td>
                        <td>{{ vendor.gstin }}</td>
                        <td>{{ vendor.pan_no }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'vendors',
  data () {
    return {
      vendors: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true
      let vendors = await axios.get(`/vendors?page=${page}&rowsPerPage=${this.rowsPerPage}&search=all`)
      this.vendors = vendors.data.data
      this.count = vendors.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    }
  }
}
</script>